
// src/reducers/account-reducer.js

import { 
  FETCH_ACCOUNT_MEMBERS,
  FETCH_ACCOUNT_MEMBERS_REQUESTED,
  FETCH_ACCOUNT_MEMBERS_COMPLETED,
  FETCH_ACCOUNT_MEMBERS_FAILED,
  FETCH_MENTION_TO_USERS,
  FETCH_MENTION_TO_USERS_REQUESTED,
  FETCH_MENTION_TO_USERS_COMPLETED,
  FETCH_MENTION_TO_USERS_FAILED,
  FETCH_OTHER_MEMBERS,
  FETCH_OTHER_MEMBERS_REQUESTED,
  FETCH_OTHER_MEMBERS_COMPLETED,
  FETCH_OTHER_MEMBERS_FAILED,
  FETCH_OTHER_MEMBERS_COUNT,
  FETCH_OTHER_MEMBERS_COUNT_REQUESTED,
  FETCH_OTHER_MEMBERS_COUNT_COMPLETED,
  FETCH_OTHER_MEMBERS_COUNT_FAILED,
  FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS,
  FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_REQUESTED,
  FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_COMPLETED,
  FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_FAILED,
  CLEAR_FETCHED_USERS,
  FETCH_GROUP_MEMBERS_USERS,
  FETCH_USERS_LENGTH,
} from '../actions/account'

import { mergeArray } from '../helpers/store'

const initialState = {
  isFetching: false,
  hasMore: true,
  hasMembers: false,
  items: undefined,
}

export default function accountReducer(state = initialState, action = {}) {
  switch(action.type) {
  case FETCH_ACCOUNT_MEMBERS_REQUESTED:
  case FETCH_MENTION_TO_USERS_REQUESTED:
  case FETCH_OTHER_MEMBERS_REQUESTED:
  case FETCH_OTHER_MEMBERS_COUNT_REQUESTED:
  case FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
    })

  case FETCH_ACCOUNT_MEMBERS_FAILED:
  case FETCH_MENTION_TO_USERS_FAILED:
  case FETCH_OTHER_MEMBERS_FAILED:
  case FETCH_OTHER_MEMBERS_COUNT_FAILED:
  case FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
    })

  case FETCH_ACCOUNT_MEMBERS_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      items: action.offset > 0 ? mergeArray('user_id', state.items, action.results) : action.results,
      hasMore: action.results.length == FETCH_USERS_LENGTH,
    })

  case FETCH_MENTION_TO_USERS_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      items: action.offset > 0 ? mergeArray('user_id', state.items, action.results) : action.results,
      hasMore: action.results.length == FETCH_USERS_LENGTH,
    })

  case FETCH_OTHER_MEMBERS_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      items: action.offset > 0 ? mergeArray('user_id', state.items, action.results) : action.results,
      hasMore: action.results.length == FETCH_USERS_LENGTH,
    })

  case FETCH_OTHER_MEMBERS_COUNT_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      hasMembers: action.results.length > 0
    })

    case FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      items: action.offset > 0 ? mergeArray('user_id', state.items, action.results) : action.results,
      hasMore: action.results.length == FETCH_USERS_LENGTH,
    })

  case CLEAR_FETCHED_USERS:
    return initialState

  case FETCH_GROUP_MEMBERS_USERS:
    return Object.assign({}, state, {
      items: action.users,
      hasMore: false,
    })

  default:
    return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/account-reducer.js